import { useTranslation } from 'react-i18next';

import Modal from 'components/Modal/Modal';

import * as S from './styled';

import { ResizableNotificationModalProps } from './types';

const ResizableNotificationModal = ({ callback, Icon, text, isDarkMode = true }: ResizableNotificationModalProps) => {
    const { t } = useTranslation();

    const { subtitle, title, buttonText } = text;

    return (
        <Modal
            isOpen
            customStyles={{
                padding: 'unset',
                width: '28%',
                maxWidth: 'none',
            }}
            dataLocator="resizableNotificationModal"
        >
            <S.DarkModeModalStyles isDarkMode={isDarkMode} />

            <S.Container>
                <S.IconContainer>
                    <Icon />
                </S.IconContainer>
                <S.Title bold center>
                    {t(title)}
                </S.Title>
                <S.Subtitle $mb={Boolean(callback && buttonText)} center>
                    {t(subtitle)}
                </S.Subtitle>
                {callback && buttonText && (
                    <S.StyledButton dataLocator="resizableNotificationModalBtn" onClick={callback}>
                        <S.ButtonText as="span">{t(buttonText)}</S.ButtonText>
                    </S.StyledButton>
                )}
            </S.Container>
        </Modal>
    );
};

export default ResizableNotificationModal;
